import React, { useContext, useEffect, useState } from 'react';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import LazyLoading from '../../../components/LazyLoading';
import { AppContext } from '../../../contexts/AppContext';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import { toast } from 'react-toastify';
import { Quality } from '../../../app/models/Quality';
import useQualityService from '../../../app/services/hooks/useQualityService';
import QualityFormContainer from './QualityFormContainer';

interface Props {
    qualityId: number;
    onSaved?: () => void;
    onCancel?: () => void;
    onError?: () => void;
}

const QualityEdit = ({ qualityId, onSaved, onCancel, onError }: Props) => {
    const { showLoading, hideLoading } = useContext(AppContext);
    const { fetchingEditQuality, editQuality, fetchingUpdateQuality, updateQuality } =
        useQualityService();

    const [quality, setQuality] = useState<Quality>({ name: '', description: '' });
    const [errorFields, setErrorFields] = useState<any>();

    useEffect(() => {
        edit();
    }, []);

    const edit = () => {
        if (showLoading) showLoading('loading', 'Cargando calidad...');
        editQuality(qualityId, {
            onSuccess: (response: ServiceResponse) => {
                setQuality(response.data.quality);
                if (hideLoading) hideLoading();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                toast.error(response.message);
                if (onError) onError();
            }
        });
    };

    const update = () => {
        if (showLoading) showLoading('loading', 'Actualizando calidad...');
        updateQuality(qualityId, quality, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });
                toast.success(response.message, { autoClose: 2500 });
                if (onSaved) onSaved();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            },
            onFieldError: (errorFields: ServiceResponse) => {
                if (hideLoading) hideLoading();
                setErrorFields(errorFields.data);
            }
        });
    };

    const cancel = () => {
        if (onCancel) onCancel();
    };

    return fetchingEditQuality ? (
        <LazyLoading height="300" />
    ) : (
        <QualityFormContainer
            fetching={fetchingUpdateQuality}
            action={update}
            cancel={cancel}
            quality={quality}
            setQuality={setQuality}
            errorFields={errorFields}
        />
    );
};

export default QualityEdit;
